module.exports = __webpack_public_path__ + "static/media/hatvan-uzemi-epulet.544a901e.jpg";